import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import { AnimatePresence } from 'framer-motion';

import Flex from '@components/layout/flex';
import MotionOpacity from '@components/motion/motion-opacity';

import InfoItem from './item-info';

export interface ItemDetail {
  label: React.ReactNode;
  streams?: React.ReactNode;
  sales?: React.ReactNode;
  earned: Dinero.Dinero;
  subitems?: ItemDetail[];
}

export interface DetailItemProps {
  className?: string;
  id: string;
  title?: React.ReactNode;
  titleHelper?: React.ReactNode;
  earned?: Dinero.Dinero;
  subtitle?: React.ReactNode;
  items?: ItemDetail[];
  isSimplified?: boolean;
}

const DetailItem: FunctionComponent<DetailItemProps> = ({
  className,
  // id,
  // title,
  // titleHelper,
  // earned,
  subtitle,
  items,
  isSimplified,
}) => {
  // const [openDetails, setOpenDetails] = React.useState<string>('');

  return (
    <MotionOpacity className={className || ''}>
      <DetailsWrapper>
        {!isSimplified && (
          <Flex justifyContent="space-between" alignItems="center">
            <Flex
              justifyContent="flex-start"
              alignItems="center"
              gap={5}
              style={{ position: 'relative' }}
            >
              {/* <Typography customFont="semi-bold">{title}</Typography> */}
              {/* {titleHelper && (
                <QuestionMarkHelper id={id}>{titleHelper}</QuestionMarkHelper>
              )} */}
            </Flex>
            {/* <Flex justifyContent="flex-end" alignItems="center" gap={20}>
              <Typography customFont="semi-bold" align="right">
                {earned && earned.toFormat()}
              </Typography>
              {items ? (
                <CircleArrowIcon
                  isWhite
                  size="24"
                  arrowUp={openDetails === id}
                  onClick={() => setOpenDetails(openDetails ? '' : id)}
                />
              ) : (
                <Spacer />
              )}
            </Flex> */}
          </Flex>
        )}
        <AnimatePresence exitBeforeEnter>
          {/* {(openDetails === id || isSimplified) && ( */}
          <InfoItem
            subtitle={subtitle}
            items={items}
            isSimplified={isSimplified}
          />
          {/* )} */}
        </AnimatePresence>
      </DetailsWrapper>
    </MotionOpacity>
  );
};

export default DetailItem;

const DetailsWrapper = styled.div`
  margin-top: 30px;
`;

// const Spacer = styled.div`
//   width: 24px;
//   height: 24px;
//   user-select: none;
//   pointer-events: none;
//   background: transparent;
// `;
